// default placeholder character.
const placeholderChar = '#';

// Returns array like:
//   [ /(\d{4})(\d{2})(\d{5})/, '$1 $2 $3' ] for format '#### ## #####'
//   [ /(\d{2})(\d{1})(\d{3})/, '($1) $2-$3' ] for format '(##) #-###'
const regexFromFormat = (format: string): [RegExp, string] => {
  let replaceWith = '';
  const selectorArray: number[] = [];
  let currentIsNumber = false;
  let currentNumber = 1;

  format.split('').forEach(char => {
    if (char === placeholderChar) {
      if (!currentIsNumber) {
        currentIsNumber = true;
        replaceWith += `$${currentNumber++}`;
        selectorArray.push(0);
      }
      selectorArray[selectorArray.length - 1]++;
    } else {
      currentIsNumber = false;
      replaceWith += char;
    }
  });

  const regex = new RegExp(selectorArray.map(n => `(\\d{${n}})`).join(''));

  return [ regex, replaceWith ];
};

// Formats for all countries.
const formats: { [key: string]: [RegExp, string] } = {
  'NO': regexFromFormat('#### ## #####'),
};

export default function formatBBAN(number?: string, countryCode = 'default') {
  if (!number) return number;
  if (!formats[countryCode]) return number;

  const regex = formats[countryCode][0];
  const replaceWith = formats[countryCode][1];

  if (!number.match(regex)) {
    // eslint-disable-next-line no-console
    console.warn('Wrong format for:', number);
  }

  return number.replace(regex, replaceWith);
}
